import workspaceQuery from '../../../graphql/queries/sales/EtsyConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/EtsyConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/EtsyConfigurationQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/EtsyConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/EtsyConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';
import defaultQuery from '../../queries/sales/EtsyConfigurationDefault.graphql';

const EtsyConfiguration: EntityType = {
  type: 'EtsyConfiguration',
  title: 'Etsy Configurations',
  formTitle: 'Etsy Configuration',
  formUrl: '/Sales/Channel/EtsyConfig/Details/',
  workspaceUrl: '/Sales/Channel/EtsyConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_ETSY_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default EtsyConfiguration;
